import axiosInstance from '../axiosInstance';

export const forgotPassword = async (email) => {
  try {
    const response = await axiosInstance.post('/auth/forgot-password', { email });
    if (!response.data.success) {
      throw response.data; 
    }

    return response.data;

  } catch (error) {
    throw error.response?.data || error;
  }
};

export const resetPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/auth/reset-password", payload);

    if (!response.data.success) {
      throw response.data;
    }
    return response.data;

  } catch (error) {
    throw error.response?.data || error;
  }
};
